import React from 'react';
import PropTypes from 'prop-types';
import { Box, CloudinaryImage } from '@stitch-fix/mode-react';
import { ShopOutfitFragmentFragment } from '../ProductDetailsPage/ShopOutfitFragment';

type OutfitItemType = ShopOutfitFragmentFragment['items'][number];

const OutfitItemCard = ({
  isSelected,
  outfitItem,
  onClick,
}: {
  isSelected?: boolean;
  outfitItem: OutfitItemType;
  onClick: (item: OutfitItemType) => void;
}) => {
  const outfitItemDetails = outfitItem?.shopProductVariant;
  const isOutOfStock =
    outfitItemDetails?.inventory?.availability === 'OUT_OF_STOCK';

  return (
    <a href={outfitItemDetails?.url}>
      <Box
        bgColor="gray-95"
        as="button"
        width={4}
        height={5.125}
        my="4px"
        minWidth={3.125}
        data-testid="image-container"
        onClick={() => (isOutOfStock ? {} : onClick(outfitItem))}
        style={{
          opacity: isOutOfStock ? 0.4 : 1,
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: isSelected ? 'black' : 'white',
          cursor: 'pointer',
        }}
      >
        <CloudinaryImage
          alt={outfitItemDetails?.image?.altText || ''}
          baseUrl={outfitItemDetails?.image?.baseUrl || ''}
          mediaPath={outfitItemDetails?.image?.mediaPath || ''}
          sizes={{
            sm: 58,
          }}
          transforms={{
            e: ['replace_color:f2f3f4:300:ffffff'],
            ar: '58:75',
          }}
        />
      </Box>
    </a>
  );
};

OutfitItemCard.defaultProps = {
  isSelected: false,
};

OutfitItemCard.propTypes = {
  isSelected: PropTypes.bool,
  outfitItem: PropTypes.shape({}),
};

export default OutfitItemCard;
